"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRetryOptions = void 0;
const fetch_retry_1 = __importDefault(require("fetch-retry"));
/**
 * We build tools for healthcare workers who are often in places with bad WIFI
 * connectivity - hospitals, GP practices, etc. We therefor assume that requests
 * are going to fail quite often due to their internet being temporarily down.
 *
 * In order to make our product feel more robust for users with bad WIFI we
 * retry all network errors up to 3 times with a delay of 1 second between each
 * attempt. If the request fails 3 times then we admit defeat and throw the
 * error.
 */
const getRetryOptions = (init, request, onFetchRetry) => {
    return {
        retryDelay: 1000,
        retryOn: (attempt, error) => __awaiter(void 0, void 0, void 0, function* () {
            /**
             * Retry up-to 3 times but only for network errors.
             *
             * NOTE: `error` will be null for any HTTP response. It will only be
             * non-null for a network error.
             */
            if (attempt < 3 && error !== null) {
                yield onFetchRetry({ init, request, error, attempt });
                return true;
            }
            return false;
        }),
    };
};
exports.getRetryOptions = getRetryOptions;
exports.default = (0, fetch_retry_1.default)(fetch);
//# sourceMappingURL=fetchRetry.js.map